import { ProductFileJoinedInterface } from 'skladon-types';

import { FileType } from 'src/types/file';
import { ProductType } from 'src/types/product';

export function productJoinedToFiles(rows?: ProductFileJoinedInterface[]): FileType[] {
    if (!rows?.length) {
        return [];
    }
    return rows.map((r) => ({
        id: r.FILE_ID,
        fileName: r.ORIGINAL_FILE_NAME,
        fileType: r.FILE_TYPE,
        fileSize: r.FILE_SIZE,
        type: r.TYPE,
        createdAt: r.CREATED_AT ?? null,
        creatorRole: r.CREATOR_ROLE ?? null,
    }));
}

export function productApiToEditData(data: ProductType): ProductType {
    const raw = (data as unknown as { FILES?: unknown[] }).FILES;
    if (!raw?.length) {
        return { ...data, FILES: [] };
    }
    const first = raw[0] as Record<string, unknown>;
    if (first.FILE_ID !== undefined) {
        return { ...data, FILES: productJoinedToFiles(raw as ProductFileJoinedInterface[]) };
    }
    return { ...data, FILES: raw as FileType[] };
}
